import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ScrollToTop from "./layouts/scrollToTop/ScrollToTop";
import reportWebVitals from "./reportWebVitals";
import "./styles/_global.scss";
import "./utils/stringUtils";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </React.StrictMode>
  </BrowserRouter>
);

reportWebVitals();
